import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import Views from '../Views';
import { theme } from '../../constants';
import content from '../../content';

const Widget = () => {
  return (
    <div className="interactive-widget" css={styles.widgetWrapper} data-name="widget-wrapper">
      <div css={styles.widgetInner}>
        <Views content={content} />
      </div>
    </div>
  );
};

const styles = {
  widgetWrapper: css`
    background-color: var(--color-white, #fff);
    margin: 0 auto;
  `,
  widgetInner: css`
    max-width: ${theme.breakpoints.wide};
    margin-inline: auto;
  `,
};

Widget.propTypes = {
  element: PropTypes.instanceOf(Element),
};

export default Widget;
